/* eslint-disable no-unused-vars */
import appConfig from "../../../app-config";
import ApiService from "../api.service";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductSupplierService = {
  /**
   * Get Screen data
   *
   * */
  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/ProductPurchase",
      expand: "Product($select=Code,Description1,StockItem,AvailableForSale,IsKit)",
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(mode, productSupplier) {
    var payload = productSupplier;
    var url = "api/ProductPurchase";

    if (mode == "create") {
      return await ApiService.post(url, payload, "Guid");
    } else {
      return await ApiService.patch(url, productSupplier.RecordId, payload, "Guid");
    }
  },

  async delete(productSupplier) {
    var payload = productSupplier;
    var url = "api/ProductPurchase";

    return await ApiService.delete(url, productSupplier.RecordId, "Guid");
  },

  async getTotalPlanningPcnt(ProductCode, RecordId) {
    const requestScreenData = {
      url: "api/ProductPurchase",
      apply: RecordId
        ? `filter(ProductCode eq '${ProductCode}' and RecordId ne ${RecordId})/aggregate(PlanningPcnt with sum as PlanningPcntTotal)`
        : `filter(ProductCode eq '${ProductCode}')/aggregate(PlanningPcnt with sum as PlanningPcntTotal)`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getSupplierByProductCode(ProductCode) {
    const requestScreenData = {
      url: "api/ProductSupplierList",
      top: "10",
      select: ["SupplierCode", "SupplierName"],
      filter: `ProductCode eq '${ProductCode}'`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },
};

export { ProductSupplierService };
